module.exports = __webpack_public_path__ + "static/media/IMG_9149.fa2a58d0.jpg";